import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { rootRoute } from './root';

const ResetPasswordPage = lazy(
  () => import('src/sections/auth/reset-password/reset-password-view')
);

export const resetPasswordRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'reset-password',
  component: () => <CompactLayout><ResetPasswordPage/></CompactLayout>,
});
